import Title from '@/components/Title';
import Banner from '@/components/Banner2';
import BusiCard from '@/components/BusiCard';
import Advantages2 from '@/components/Advantages2';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    Title,
    Banner,
    BusiCard,
    Advantages2,
    Appointment2
  },
  data() {
    return {
      bannerData: {
        imageUrl: require('@/assets/images/technology/AiWriter/aiwriter-banner.png'),
        bannerTitle: '自动写文章',
        bannerText: '集合了同花顺领先的自然语言处理和知识图谱技术，提供自动写作和辅助写作的能力，全面提升内容创作效率，旨在成为最懂你的智能写作助手'
      },
      functionsData: [{
        icon: require('@/assets/images/technology/AiWriter/aiwriter-func1.png'),
        title: '智能写诗与春联',
        text: '智能写诗与春联利用自主创新的神经网络生成技术，实现了机器根据命题进行智能写诗、智能春联'
      }, {
        icon: require('@/assets/images/technology/AiWriter/aiwriter-func2.png'),
        title: '结构化数据写作',
        text: '内置丰富素材和数据，支持从结构化数据到文本的自动生成'
      }, {
        icon: require('@/assets/images/technology/AiWriter/aiwriter-func3.png'),
        title: '素材辅助写作',
        text: '提供热点发现能力、热点事件脉络，自动摘要和自动纠错等能力'
      }],
      businessesData: [{
        icon: require('@/assets/images/technology/AiWriter/aiwriter-bus1.png'),
        title: '媒体与内容创作行业',
        text: '适用于财经、体育、天气、热点与娱乐事件等多样内容的自动写作与辅助写作，大幅提升创作效率'
      }, {
        icon: require('@/assets/images/technology/AiWriter/aiwriter-bus2.png'),
        title: '商业智能',
        text: '适用于企业内外部数据的自动分析与报告生成，提升企业信息同步效率与管理效率'
      }, {
        icon: require('@/assets/images/technology/AiWriter/aiwriter-bus3.png'),
        title: '行业报告与咨询机构',
        text: '适用于对行业热点咨询、最新动态等信息的追踪、监测与报告的自动生成，大幅提升信息处理效率'
      }, {
        icon: require('@/assets/images/technology/AiWriter/aiwriter-bus4.png'),
        title: '市场营销与活动',
        text: '运用智能创作技术，帮助企业打造更多趣味性营销活动，提升用户体验与传播价值'
      }],
      leftItems: [{
        title: '技术领先',
        desc: '基于深度学习与大数据优势，提供领先的深度理解能力与生成技术'
      }],
      rightItems: [{
        title: '简单易用',
        desc: '配置简单、生成快速，零代码基础也可轻松使用'
      }, {
        title: '能力丰富',
        desc: '内置丰富数据、素材，融合多种自然语言处理与知识图谱能力'
      }]
    };
  }
};